import { jsx as _jsx } from "react/jsx-runtime";
import { Link as ChakraLink } from '@chakra-ui/react';
const ExternalLink = ({ children, ...rest }) => {
    return (_jsx(ChakraLink, { role: 'link', target: '_blank', rel: 'noreferrer noopener', ...rest, children: children }));
};
export default ExternalLink;
